export default "__VITE_ASSET__Cr4hEgIA__"